define([
    "csi/config",
    "dojo/_base/declare",
    "./OptionalAttributesTable"
], function(config,declare,OptionalAttributesTable) {

    var CONFIG_CLASS_NAME = "SpecificationDataSheetRevision";
    var CONFIG_ATTRIBUTE_ID = "DataSheetOptionalAttributes";

    OptionalAttributesTable.watchBooleanValue();

    return declare(OptionalAttributesTable, {
        configNodeType: CONFIG_CLASS_NAME,
        configAttributeId: CONFIG_ATTRIBUTE_ID
    });
});